import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const CreateIssueRequest = React.lazy(() => import("./CreateIssueRequest"));
const IssueCategoryList = React.lazy(() => import("./IssueCategoryList"));
const IssueDetails = React.lazy(() => import("./IssueDetails"));
const IssueManagerLogs = React.lazy(() => import("./IssueManagerLogs"));
const EscalatedLogs = React.lazy(() => import("./escalatedLogs"));
const AssignedPerson = React.lazy(() => import("./AssignedPerson"));
const ApproveRequest = React.lazy(() =>
    import("./ApprovalRequest/ApprovalTable")
);
export const IssuesConfigs = [
    {
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
        ],
        path: "/issue/list",
        element: <CreateIssueRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.FRONTDESK,
            // RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
        ],
        path: "/issue/approval",
        element: <ApproveRequest />,
    },
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN],
        path: "/issue/category",
        element: <IssueCategoryList />,
    },
    {
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            // RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/issue/logs",
        element: <IssueManagerLogs />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/issue/escalated",
        element: <EscalatedLogs />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.SETUP_MANAGER,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
        ],
        path: "/issue/detail/:id",
        element: <IssueDetails />,
    },
    {
        permittedRole: [
            // RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
        ],
        path: "/issue/assign",
        element: <AssignedPerson />,
    },
];
